const handleItems = (items, renderLimit, addPlaceholder = true) => {
  const itemsList = items.slice(0, renderLimit)
  if (itemsList.length <= renderLimit && addPlaceholder) {
    const placeHolder = Array.from(new Array(renderLimit - itemsList.length)).map((_) => ({ img: undefined }))
    return [...itemsList, ...placeHolder]
  }
  return itemsList
}

const ImageBlockRemainingItemCount = ({ remainingItems }) => {
  if (remainingItems === 0) return
  return (
    <div
      className={'absolute inset-0 z-10 m-auto flex h-full  w-full flex-col items-center justify-center bg-black/50'}
    >
      <div className={'paragraph-lg font-bold text-primary-white'}>+{remainingItems}</div>
    </div>
  )
}

const ImageBlock = ({ item, totalItems, index, remainingItems, renderLimit }) => {
  return (
    <div className={'relative aspect-square w-full md:w-[156px] md:only:col-span-2'}>
      {index + 1 >= renderLimit && <ImageBlockRemainingItemCount remainingItems={remainingItems} />}
      {!item?.img ? (
        <div className={'h-full w-full bg-neutrals-base'}></div>
      ) : (
        <img className={'h-full w-full object-cover object-bottom'} src={item.img} />
      )}
    </div>
  )
}

export function ImageGalleryLimit({ array, renderLimit }) {
  const items = handleItems(array, renderLimit, false)
  const remainingItems = array.length - renderLimit
  return (
    <>
      {items.map((item, index) => {
        return (
          <ImageBlock
            renderLimit={renderLimit}
            index={index}
            totalItems={items.length}
            item={item}
            remainingItems={remainingItems}
          />
        )
      })}
    </>
  )
}
